const Hero = () => {
  return (
    <>
      <section className='hero' id='home'>
        <div className='hero-banner'>
          <h1>TechSolu</h1>
          <p>
           We specialize in delivering comprehensive IT Consultancy services tailored for both businesses and individuals
          </p>
          <a href='#projects' className='btn hero-btn'>
            explore Our Projects
          </a>
        </div>
      </section>
    </>
  );
};
export default Hero;
